import React, { useMemo } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { ButtonWithDropdown } from '@xingternal/winery-ui/lib/ButtonWithDropdown';
import { ButtonMenu } from './ButtonMenu';
import { DropdownMenu } from './DropdownMenu';

type ButtonWithDropdownWrapperProps = {
  hasOnlyButtons?: boolean;
  hasButtonsAndDrop?: boolean;
};
const ButtonWithDropdownWrapper = styled(
  ButtonWithDropdown,
)<ButtonWithDropdownWrapperProps>`
  align-items: center;
  button {
    border-radius: ${(props) => props.hasOnlyButtons && 0};

    &:first-child {
      border-top-left-radius: ${(props) =>
        props.hasOnlyButtons && themeGet('radii.1')};
      border-bottom-left-radius: ${(props) =>
        props.hasOnlyButtons && themeGet('radii.1')};
    }
    &:last-child {
      border-top-right-radius: ${(props) =>
        props.hasOnlyButtons && themeGet('radii.1')};
      border-bottom-right-radius: ${(props) =>
        props.hasOnlyButtons && themeGet('radii.1')};
      border-left: ${(props) => props.hasButtonsAndDrop && 'none'};
    }
    &:not(:first-child):not(:last-child) {
      border-radius: ${(props) => props.hasButtonsAndDrop && 0};
      border-left: ${(props) => props.hasButtonsAndDrop && 'none'};
    }
  }
`;

export enum OptionType {
  dropdown = 'dropdown',
  button = 'button',
}

export interface Item {
  item: React.ReactNode;
  action: () => void;
  disabled: boolean;
  datatestid?: string;
  buttonIcon?: string;
  type: OptionType;
}
interface MultiMenuProps {
  triggerIcon?: string;
  closeOnClick?: boolean;
  dropdownWidth?: number;
  items?: Item[];
  testid?: string;
}

const MultiMenu = ({
  triggerIcon,
  items,
  dropdownWidth,
  closeOnClick = true,
  testid = 'dropdown-list',
}: MultiMenuProps) => {
  const { dropdown, button } = useMemo(
    () =>
      items?.reduce(
        (acc, item) => {
          acc[item.type].push(item);
          return acc;
        },
        {
          dropdown: [],
          button: [],
        },
      ),
    [items],
  );

  const hasDropdownItems = !!dropdown.length;
  const hasButtonsItems = !!button.length;

  return (
    <ButtonWithDropdownWrapper
      hasOnlyButtons={!hasDropdownItems}
      hasButtonsAndDrop={hasButtonsItems && hasDropdownItems}
    >
      {!!hasButtonsItems && <ButtonMenu items={button} />}
      {!!hasDropdownItems && (
        <DropdownMenu
          icon={triggerIcon}
          items={dropdown}
          listWidth={dropdownWidth}
          closeOnClick={closeOnClick}
          testid={testid}
          hasOnlyDropdown={!hasButtonsItems}
        />
      )}
    </ButtonWithDropdownWrapper>
  );
};

export { MultiMenu };
